<div id="vehicle">
    <div class="container-fluid">
        <div class="row cbrow">
            <div *ngIf="!isInitCarousel" class="loading">
                <img src="assets/loading.svg" alt="{{'stats.common.loading'|translate}}" />
            </div>
            <div class="owl-theme" *ngIf="isInitCarousel">
                <div class="owl-nav">
                    <div class="owl-prev" (click)="owlElement.prev()" role="button">&lsaquo;</div>
                </div>
            </div>
            <owl-carousel-o #slider id="slider" class="carousel" *ngIf="isInitCarousel" [options]="mySlideOptions" [items]="images" [carouselClasses]="['owl-theme', 'sliding']" (keyup)="key($event)" (drag)="drag($event)">
                <ng-container *ngFor="let image of mySlideImages; index as idx">
                    <ng-template carouselSlide [id]="'slide' + idx">
                        <div class="sizeCarousel item" (keyup)="key($event)">
                            <div class="sizeImg" (keyup)="key($event)">
                                <img class="logo sizeImg" id="{{image.name}}" src="{{image.src}}" (click)="displayModels($event,image.name, image.position)" (keyup)="key($event)" alt="{{image.name}}" />
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
            </owl-carousel-o>
            <div class="owl-theme" *ngIf="isInitCarousel">
                <div class="owl-nav">
                    <div class="owl-next" (click)="owlElement.next()" role="button">&rsaquo;</div>
                </div>
            </div>
            <div class="button" (keyup)="key($event)"></div>

            <div class="formDiv" *ngIf="isInitCarousel">
                <!--<i  aria-hidden="true" class="far fa-search col-1"></i>-->
                <form [formGroup]="Form" class="searchDiv">
                    <div class="search dropdownManufacturer backgroundWhiteRound">
                        <input type="text" placeholder="{{'common.search'|translate}}" [matAutocomplete]="auto" class="searchDD" formControlName="manufacturerCtrl" />
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="DropdownSelected($event)">
                            <mat-option *ngFor="let m of filteredOptions | async" value="{{m.name}}">{{m.name}}</mat-option>
                        </mat-autocomplete>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="models">
        <mat-grid-list cols="{{breakpoint}}" rowHeight="{{heightSize}}" (window:resize)="onResize($event)">
            <mat-grid-tile class="model" *ngFor="let model of modelLstToShow" (click)="SelectModel(model)">
                <div class="modelinfo backgroundWhiteRound" *ngIf="model.isVisible">
                    <label class="modelName">{{model.name}}</label>
                    <div class="aligncenter">
                        <img class="imgVehicle" #{{model.name}} src="{{model.picture}}" alt="" />
                    </div>
                    <div *ngIf="!model.isGamme" class="modelDate">
                        <label>{{model.dateDeb}}</label>
                        <label>{{model.dateFin}}</label>
                    </div>
                </div>
            </mat-grid-tile>
        </mat-grid-list>
    </div>
</div>
